@if (isLoaded()) {
<div id="container-setup" class="d-flex align-items-stretch">

  <div class="col-2 menu-config-site me-2">
    <ul class="nav flex-column ms-2">
      @for (item of arrayMenu; track item.tab) {
        <li class="nav-item item-config">
          <a class="nav-link" 
             [routerLink]="[item.routePath]"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{exact: false}">
            {{item.translateId | translate}}
          </a>
        </li>
      }
    </ul>
  </div>

  <div class="col-xl-10">
    <router-outlet></router-outlet>
  </div>
</div>
}